import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  defineComponent,
  ref,
  computed,
  onMounted,
  onBeforeUnmount
} from 'vue';
import ModalWrapper from '@/shared/legacy/ui/modal-next/modal-wrapper.vue';
import { appConfig } from '@/shared/legacy/lib/config/app-config';


export default /*@__PURE__*/_defineComponent({
  __name: 'app-version-info',
  setup(__props) {

const showApp = ref(false);
const handleKeyDown = (event: KeyboardEvent) => {
  const isShowVersionShortcut
    = event.code === 'Backquote' && (event.ctrlKey || event.metaKey) && event.shiftKey;
  if (isShowVersionShortcut) {
    showApp.value = !showApp.value;
  }
};

onMounted(() => document.addEventListener('keydown', handleKeyDown));
onBeforeUnmount(() => document.removeEventListener('keydown', handleKeyDown));
const version = computed(() => appConfig.config.value?.version.split('-')[0]);

defineComponent({
  name: 'AppVersionInfo'
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalWrapper, {
    open: showApp.value,
    onChange: _cache[0] || (_cache[0] = ($event: any) => (showApp.value = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.appVersionInfo)
      }, _toDisplayString(version.value), 3)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})